import React, { useEffect, useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import CardAccordion from "./_card_accordion";
import E_PaginatationComponent from "./_card_pagination";
import CardLink from "./_card_link";
import { useSelector } from "react-redux";
import {Skeleton} from '@material-ui/lab';
const useStyle = makeStyles((theme)=>({
  gridContain: {
    height: "52vh",
    marginTop: "2%",
    [theme.breakpoints.down("sm")]: {
      height:"100%"
    },
  },
  dataHeight: {
    height:"46vh",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      height: "100%",
     }
  },
  linkStatement: {
    padding: "5%",
    [theme.breakpoints.up("md") && theme.breakpoints.down("sm")]: {
      padding:"2% 5% !important"
     },
  },
  bottomMargin:{
    marginBottom:"2%"
  }
}));

export default function CardData({ data, origin, searchContent, contentReady }) {
  let classes = useStyle();
  let count = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_SEARCH_PAGINATION
  );
  const [page, setPage] = useState(1);
  const [totalPagesCount, setTotalPagesCount] = useState(
    Math.ceil(data?.length / count)
  );
  const [paginationData, setPaginationData] = useState();
  useEffect(() => {
    if (Math.ceil(data?.length / count) !== totalPagesCount) {
      setTotalPagesCount(Math.ceil(data?.length / count));
    }
  }, [data]);
  useEffect(() => {
    if (data) {
      setPaginationData(data?.slice((page - 1) * count, page * count));
    }
  }, [data, page]);
  useEffect(() => {
    setPage(1);
  }, [data]);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  return (
    <div className={classes.gridContain}>
      <div className={classes.dataHeight}>
        {origin === "LINKS" && (
          contentReady ?
          <Typography variant="subtitle2" className={classes.linkStatement}>
            {searchContent("E_SEARCH_CLICK_LINK").answer}
          </Typography>
          : <Skeleton />
        )}
        {paginationData &&
          paginationData.map((item, k) => (
            <div key={k}>
              {origin !== "LINKS" ? (
                <CardAccordion
                  item={item}
                  k={item?._source?.ContentCategoryCode}
                />
              ) : (
                <CardLink item={item} k={item?._source?.ContentLanguageId} />
              )}
            </div>
          ))}
      </div>
      {totalPagesCount > 1 ? (
        <E_PaginatationComponent
          totalPagesCount={totalPagesCount}
          page={page}
          handlePageChange={handlePageChange}
        />
      ):<div className={classes.bottomMargin}/>}
    </div>
  );
}
